import { render, staticRenderFns } from "./AltCoinXChangeOfflinePool.vue?vue&type=template&id=4d02dc31&scoped=true&"
import script from "./AltCoinXChangeOfflinePool.vue?vue&type=script&lang=js&"
export * from "./AltCoinXChangeOfflinePool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d02dc31",
  null
  
)

export default component.exports